import React from "react";
import styles from "./Styles";
import { Card, CardContent, Typography, List } from "@material-ui/core";
import ListItem from "@material-ui/core/ListItem";
import { Link } from "react-admin";
import { canAccess } from "../../rbac";

const FLEET_ITEMS = [
  { to: "/moto_schedule/start", text: "Bike Schedule", permission: "moto_schedule" },
  { to: "/gps_schedule/start", text: "Gps Schedule", permission: "gps_schedule" },
  { to: "/vans_schedule/start", text: "Vans Schedule", permission: "vans_schedule" },
  { to: "/vehicles", text: "Vehicles", permission: "vehicles" },
  { to: "/current_fleet", text: "Current Fleet", permission: "current_fleet" },
  { to: "/fleet_allocation", text: "Fleet Allocation", permission: "fleet_allocation" },
  { to: "/transfers", text: "Transfers", permission: "transfers" },
  { to: "/maintenances_due", text: "Maintenance Due", permission: "maintenances_due" },
  { to: "/holds", text: "Holds", permission: "holds" },
  { to: "/vehicle_damages", text: "Damages", permission: "vehicle_damages" },
];

export class FleetOptions extends React.Component {
  render() {
    return (
      <Card style={styles.cardStyle}>
        <Typography
          gutterBottom
          variant="h6"
          component="h2"
          style={styles.cardHeaderStyle}
        >
          Bikes / Vans / GPS
        </Typography>
        <CardContent style={styles.CardContent}>
          <List>
            {FLEET_ITEMS.map(({ to, text, permission }) =>
              canAccess(permission) ? (
                <ListItem key={to}>
                  <Link to={to}>{text}</Link>
                </ListItem>
              ) : null
            )}
          </List>
        </CardContent>
      </Card>
    );
  }
}

export default FleetOptions;



// WEBPACK FOOTER //
// ./src/components/dashboard/FleetOptions.js